<script lang="ts">
    import Checkbox from "./Checkbox.svelte";
    export let checkboxes: { label: string; value: string }[];
    export let checkedValues: string[] = [];
    export let label: string;
    export let onChange: (checkedValues: string[]) => void;
</script>

<div class="InlineCheckboxes form-item form-item--checkboxes">
    <div class="InlineCheckboxes__label">{label}</div>
    <div class="InlineCheckboxes__input">
        {#each checkboxes as checkbox (checkbox.value)}
            <Checkbox
                value={checkbox.value}
                onChange={(checked) => {
                    const index = checkedValues.indexOf(checkbox.value);
                    if (checked) {
                        if (index === -1) {
                            const newCheckedValues = [
                                ...checkedValues,
                                checkbox.value,
                            ];
                            onChange(newCheckedValues);
                        }
                    } else if (index > -1) {
                        const newCheckedValues = [...checkedValues];
                        newCheckedValues.splice(index, 1);
                        onChange(newCheckedValues);
                    }
                }}
                checked={checkedValues.indexOf(checkbox.value) > -1}
                >{checkbox.label}</Checkbox
            >
        {/each}
    </div>
</div>

<style type="text/scss">
    @import "../../../scss/config.scss";

    .InlineCheckboxes {
        &__label {
            font-size: 0.85rem;
            color: lighten($color-base, 15%);
        }
        &__input {
            margin-top: 15px;
            :global(label) {
                display: inline-block;
                margin-right: 20px;
            }
        }
        :global(.Checkbox) {
            min-height: 20px;
            margin-bottom: 10px;
        }
        user-select: none;
    }
</style>
